import React, { CSSProperties, PropsWithChildren, useEffect, useMemo } from "react";
import { Theme } from "@radix-ui/themes";
import { ThemV2 as QuackThemeVars } from "../entities/ChatSettingsV2";
import { loadGoogleFont } from "../utils/loadGoogleFont";

interface QuackChatWidgetThemeProps {
  themeVars: QuackThemeVars;
}

export function QuackChatWidgetTheme({
  children,
  themeVars,
}: PropsWithChildren<QuackChatWidgetThemeProps>) {

  useEffect(() => {
    if (themeVars.fontFamily) {
      loadGoogleFont(themeVars.fontFamily);
    }
  }, [themeVars.fontFamily]);

  const themeParams = useMemo<CSSProperties>(() => {
    const params: Record<string, string> = Object.fromEntries(
      Object.entries(themeVars).map(([key, value]) => {
        if (key === "fontFamily") {
          return ["--qc-font-family", value];
        }
        return [`--${key}`, value];
      })
    );

    return params;
  }, [themeVars]);

  return (
    <Theme
      className="qc-themes light"
      accentColor={"gray"}
      grayColor={"slate"}
      style={themeParams}
      radius={"medium"}
    >
      {children}
    </Theme>
  );
}
